'use client';
import Image from '@/src/components/Image';
import { SliderLayout } from '@/src/components/Layout/SliderLayout';
import { CarouselApi } from '@/src/components/ui/carousel';
import Container from '@/src/components/ui/container';
import { FC, useEffect, useState } from 'react';
import Autoplay from 'embla-carousel-autoplay';
import { IHeroBanner } from '../services/types';
import RenderDestination from './RenderDestination';

type Props = {
  data: IHeroBanner[];
  branchId?: number;
};

export const HeroBanner: FC<Props> = ({ data, branchId }) => {
  const [carouselApi, setCarouselApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (!carouselApi) {
      return;
    }
    setCurrent(carouselApi?.selectedScrollSnap() + 1);
    carouselApi.on('select', () => {
      setCurrent(carouselApi.selectedScrollSnap() + 1);
    });
  }, [carouselApi]);

  return (
    <Container>
      <SliderLayout
        setApi={setCarouselApi}
        opts={{
          align: 'center',
          dragFree: false,
        }}
        plugins={[Autoplay({ delay: 4000 })]}
      >
        {data.map((item) => (
          <RenderDestination key={item.Id} destination={item.Destination} branchId={branchId}>
            <div className="relative aspect-2/1 w-full overflow-hidden rounded-3xl">
              <Image
                src={item.EnglishImage}
                alt={item.Id}
                fill
                className="h-full w-full object-cover"
                preload
                sizes="(min-width: 1420px) 1280px, calc(90.18vw + 17px)"
              />
            </div>
          </RenderDestination>
        ))}
      </SliderLayout>

      <ul className="mt-2 flex items-center justify-center gap-2">
        {data.map((_, index) => (
          <li
            onClick={() => {
              carouselApi?.scrollTo(index);
            }}
            key={`slider-page-${index}`}
            aria-label="Scroll to item" // Accessible name
            data-active={index === current - 1 ? 'true' : 'false'}
            className="data-[active=true]:bg-primary h-2.5 w-2.5 cursor-pointer rounded-full transition-all duration-700 data-[active=false]:bg-[#CFCFCF]"
          />
        ))}
      </ul>
    </Container>
  );
};
